module.exports = __webpack_public_path__ + "static/media/video7.f605be00.jpg";